import './src/vaadin-details.js';
export * from './src/vaadin-details.js';
